import { Card, ErrorContainer, useMounted, icons, sizing, useToast, useModal } from '@chillibean/component-library';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { AdminHeroBox } from '../../../../../HeroBox/AdminHeroBox/AdminHeroBox';
import { AdminList, ReasonForDeleteModal } from '../../components/container';
import { fetchProtocols, duplicateProtocol } from '../../redux/actions';

export function ProtocolsPage() {
  // HOOKS
  // Router
  const history = useHistory();
  const { url } = useRouteMatch();
  // Store
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.internalReducer.internal);
  const { data: protocols, error, loading } = useSelector((state) => state.protocolsReducer.protocols);
  // Custom
  const { mounted } = useMounted({ requiredValues: [account] });
  const { showErrorToast, showSuccessToast } = useToast();
  const {
    closeModal: closeReasonForDeleteModal,
    modalOpen: reasonForDeleteModalOpen,
    openModal: openReasonForDeleteModal,
  } = useModal();
  const [selectedId, setSelectedId] = useState();

  useEffect(() => {
    if (mounted) {
      dispatch(fetchProtocols());
    }
  }, [mounted]);

  const goToNewProtocol = () => {
    history.push(`${url}/new`);
  };

  const goToProtocol = (id) => {
    history.push(`${url}/${id}`);
  };

  const closeModal = () => {
    setSelectedId();
    closeReasonForDeleteModal();
  };

  const onDeleteProtocolClick = (id) => {
    setSelectedId(id);
    openReasonForDeleteModal();
  };

  const onDuplicateProtocolClick = (id) => {
    dispatch(
      duplicateProtocol({
        identifier: id,
        onError: showErrorToast,
        onSuccess: (response) => {
          showSuccessToast('Trial Configuration duplicated successfully');
          goToProtocol(response.id);
        },
      }),
    );
  };

  const onDeleteProtocolConfirm = () => {
    closeModal();
    dispatch(fetchProtocols());
  };

  if (error)
    return (
      <Container>
        <ErrorContainer error={error} retry={() => dispatch(fetchProtocols())} />
      </Container>
    );

  return (
    <Container>
      <ReasonForDeleteModal
        onClose={closeModal}
        onSuccess={onDeleteProtocolConfirm}
        protocolId={selectedId}
        visible={reasonForDeleteModalOpen}
      />
      <BoxContainer>
        <AdminHeroBox
          button={{ onClick: goToNewProtocol, text: 'Create New' }}
          content="Trial Configurations are containers that allow you to control the settings for organizing a study. Within Trial Configuration, you can create a study scheduler based on the original trial document, which determines which assessments belong to which visits within that trial. The data you build in Trial Configuration will be automatically populated for each of the study's Sites."
          header="TRIAL CONFIGURATIONS"
          icon={icons.baselineFormatBulletList}
          loading={loading}
          subHeader="Trial Configuration List"
        />
      </BoxContainer>
      <ListContainer>
        {!loading && !protocols.length && <Card disabled>No protocols defined</Card>}
        {(loading || Boolean(protocols.length)) && (
          <AdminList
            elements={protocols.map((protocol) => protocol.listParams({ onClick: goToProtocol }))}
            loading={loading}
            onDelete={onDeleteProtocolClick}
            onDuplicate={onDuplicateProtocolClick}
            rightSectionEnabled
          />
        )}
      </ListContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizing.medium};

  padding: ${sizing.xlarge};
`;

const BoxContainer = styled.div`
  padding: 0 15px;
`;

const ListContainer = styled.div`
  padding: 0 15px;
`;

export default ProtocolsPage;
